module.exports = __webpack_public_path__ + "img/dot-002.46ea8901.svg";